import ErrorBoundary from "./ErrorBoundary";
import ErrorBoundaryFallback from "./ErrorBoundaryFallback";
import withErrorFallback from "./withErrorFallback";

export default ErrorBoundary;

export {ErrorBoundaryFallback, withErrorFallback};
